export default "__VITE_ASSET__DSQVVrvF__"